import useGet from '../hooks/useGet';
import { Experience, ExperienceCode } from '../types/Experience';
export const useGetLandingPageResource = (experience) => {
    const experienceCode = experience === Experience.EMPLOYEE ? ExperienceCode.EMPLOYEE : ExperienceCode.EMPLOYER;
    return useGet({
        url: `/mlp-ui-service/services/v1/landing-page?experience=${experienceCode}`,
        noInitial: true,
    });
};
